import Typography from "@/foundation/Typography/V2";

import ConditionItem from "./ConditionItem";

import { classNameGenerator } from "@/utils";

import styles from "./SymptomsAndConditionsSection.module.scss";
import CallbackSection from "../CallbackSection";
import CallbackSectionDesktop from "../CallbackSectionDesktop";
import { useAppSelector } from "@/hooks";

interface SymptomsAndConditionsSectionProps {
  titleDesktop?: string;
  titleMobile?: string;
  isTrialPage?: boolean
}

const SymptomsAndConditionsSection: React.FC<
  SymptomsAndConditionsSectionProps
> = ({ titleDesktop, titleMobile, isTrialPage }) => {
  const cls = classNameGenerator(styles);
  const { data } = useAppSelector((state) => state.bootCamp);

  const { webHeading, mobileHeading, condition} = data?.SymptomsAndConditions || {}

  const _titleDesktop =
  webHeading || titleDesktop ||
    "We have different Yoga classes for the following health concerns and goals";
  const _titleMobile =
  mobileHeading || titleMobile || "Manage and reverse symptoms for conditions with Yoga —";
  const conditions = [
    {
      icon: "icon-bootcamp-wellness",
      title: "Wellness",
    },
    {
      icon: "icon-bootcamp-strength",
      title: "Strength & <br/>Flexibility",
    },
    {
      icon: "icon-bootcamp-pcos",
      title: "PCOS",
    },
    {
      icon: "icon-bootcamp-high-bp",
      title: "High BP",
    },
    {
      icon: "icon-bootcamp-thyroid",
      title: "Thyroid",
    },
    {
      icon: "icon-bootcamp-prenatal",
      title: "Prenatal <br/>care",
    },
    {
      icon: "icon-bootcamp-postnatal",
      title: "Postnatal <br/>care",
    },
    {
      icon: "icon-bootcamp-back",
      title: "Back <br/>Strengthening",
    },
    {
      icon: "icon-bootcamp-diabetes",
      title: "Diabetes",
    },
    {
      icon: "icon-bootcamp-digestion",
      title: "Good <br/>Digestion",
    },
  ];

  return (
    <section className={cls("symptomsAndConditionsSection")}>
      <div className={cls("container")}>
        <Typography variant="heading2" className={cls("title")}>
          {_titleMobile}
        </Typography>
        <Typography variant="heading2" className={cls("titleDesktop")}>
          {_titleDesktop}
        </Typography>
        <div className={cls("conditions")}>
          {(condition || conditions)?.map((condition, index) => (
            <ConditionItem key={index} {...condition} />
          ))}
        </div>
      </div>
      {isTrialPage && <CallbackSectionDesktop titleText="Want to know more?" descriptionText="Request a callback"/>}
     {isTrialPage && <CallbackSection titleText="Want to know more?" descriptionText="Request a callback"/>}
    </section>
  );
};

export default SymptomsAndConditionsSection;
